import { useCallback } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { ShareActionsOptions } from '#src/app/shared/hooks/share';

import type { CommentShareChannel, PartialComment } from '../types';

export function useGetCommentShareContent(
	comment: PartialComment,
): ShareActionsOptions<CommentShareChannel>['getContent'] {
	const { translate } = useI18n();

	return useCallback(
		(channel) => {
			switch (channel) {
				case 'twitter':
					return `${translate('fe.pages.comment.twitter_message')} ${comment.comment}`;
				default:
					// no text for FB
					return '';
			}
		},
		[comment, translate],
	);
}
